import apiAddress from "./apiAddress";
const api = `${apiAddress}/api/v1`;
export default api;
